// core
import './checkVersion'
import './lib/gtm-module'
import './lib/mixpanel'
// css
import './styles/global.css'
import 'react-credit-cards/es/styles-compiled.css'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

// head
import { HeadScripts } from '@components/HeadScripts'
// local components
import { EnforcerOneTab } from '@components/index'
import { isInternal, isProduction } from '@config/api'
// context
import AppProvider from '@shared/infra/hooks'
// router
import AppRoutes from '@shared/infra/router'
import { ErrorBoundary } from 'react-error-boundary'
import { withOneTabEnforcer } from 'react-one-tab-enforcer'
import { BrowserRouter as Router } from 'react-router-dom'

import ErrorFallback from './components/errorFallback'

function App(): JSX.Element {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Router>
        <AppProvider>
          <HeadScripts />
          <AppRoutes />
        </AppProvider>
      </Router>
    </ErrorBoundary>
  )
}

let exportApp = App

if (isProduction || isInternal) {
  exportApp = withOneTabEnforcer({
    appName: document.title,
    OnlyOneTabComponent: EnforcerOneTab,
  })(App)
}

export default exportApp
